var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 606.625,
    height: 720,
    viewBox: "0 0 606.625 720",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-789 -270.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M797.411,247.279A24.721,24.721,0,0,0,774.8,232.154H323.562A24.474,24.474,0,0,0,299.1,256.615V827.478a24.474,24.474,0,0,0,24.461,24.461H774.82a24.493,24.493,0,0,0,24.461-24.461V256.615a24.029,24.029,0,0,0-1.854-9.335Zm-3.578,580.2A19.052,19.052,0,0,1,774.8,846.506H323.562a19.031,19.031,0,0,1-19.029-19.022V256.618a19.055,19.055,0,0,1,19.029-19.029H774.82a19.123,19.123,0,0,1,17.663,11.97,21.087,21.087,0,0,1,.715,2.147,18.869,18.869,0,0,1,.651,4.912Z",
    transform: "translate(489.898 138.561)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.54,312.161H442.619a10.874,10.874,0,0,1,0-21.748H578.54a10.874,10.874,0,1,1,0,21.748Z",
    transform: "translate(614.601 193.333)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.54,341.585H442.619a10.874,10.874,0,0,1,0-21.748H578.54a10.874,10.874,0,1,1,0,21.748Z",
    transform: "translate(614.601 220.995)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.465,416.457h-99.33A12.247,12.247,0,0,1,343.9,404.223V287.006a12.247,12.247,0,0,1,12.234-12.234h99.33A12.247,12.247,0,0,1,467.7,287.006V404.223A12.247,12.247,0,0,1,455.465,416.457Z",
    transform: "translate(532.016 178.628)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.041,401.835H353.861a10.874,10.874,0,0,1,0-21.748h307.18a10.874,10.874,0,1,1,0,21.748Z",
    transform: "translate(531.157 277.638)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.041,431.258H353.861a10.874,10.874,0,0,1,0-21.748h307.18a10.874,10.874,0,1,1,0,21.748Z",
    transform: "translate(531.157 305.3)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.041,460.682H353.861a10.874,10.874,0,0,1,0-21.748h307.18a10.874,10.874,0,1,1,0,21.748Z",
    transform: "translate(531.157 332.962)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.041,490.106H353.861a10.874,10.874,0,0,1,0-21.748h307.18a10.874,10.874,0,1,1,0,21.748Z",
    transform: "translate(531.157 360.625)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.041,519.53H353.861a10.874,10.874,0,0,1,0-21.748h307.18a10.874,10.874,0,1,1,0,21.748Z",
    transform: "translate(531.157 388.287)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.941,
    cy: 104.941,
    r: 104.941,
    transform: "translate(1185.743 270.5)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.583,293.9a10.884,10.884,0,0,1-6.548-2.176l-.117-.088-24.663-18.866a10.96,10.96,0,1,1,13.336-17.4l15.975,12.25,37.748-49.247a10.955,10.955,0,0,1,15.36-2.029l0,0-.234.325.241-.325a10.969,10.969,0,0,1,2.026,15.363l-44.4,57.9a10.962,10.962,0,0,1-8.717,4.274Z",
    transform: "translate(710.7 121.575)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.8b6539af.svg";
export { ForwardRef as ReactComponent };